<template>
  <div class="justify-content-center row no-gutters mobileAuthForm">

    <div class="col-12">
      <img src="./../../assets/logo.png" title="BestUse" id="logo" alt='BestUse' class="col-md-3 col-lg-2"/>
    </div>

    <div class="col-md-8 col-lg-4 col-xl-3 mt-5">

      <div class="row">
        <div class="col-12 input-group ">
          <div class="input-group-prepend">
            <span class="input-group-text" >
              <font-awesome-icon icon="user" />
            </span>
          </div>
          <input @keyup.enter="logar()"
            v-model="form.login"
            type="text"
            class="form-control"
            placeholder="Login"
            aria-label="Login"
          >
        </div>

        <div class="col-12 input-group mt-2">
          <div class="input-group-prepend">
            <span class="input-group-text" >
              <font-awesome-icon icon="lock" />
            </span>
          </div>
          <input @keyup.enter="logar()"
            v-model="form.password"
            type="password"
            class="form-control"
            placeholder="Senha"
            aria-label="Senha"
          >
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
            <my-alert
              class="alert-danger mt-2 col-12 text-center"
              @done='showError = false'
              :message ='errorMessage'
              :show='showError'
            ></my-alert>

            <my-alert
              class="alert-success mt-2 col-12 text-center"
              @done='showSuccess = false'
              :message ='successMessage'
              :show='showSuccess'
            ></my-alert>
          </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-12 mb-2">
          <button class="btn btn-md btn-primary btn-block" type="button" @click="logar()">acessar</button>
        </div>

      </div>
      <div class="row mt-3">
        <div class="col-md-12">
           <button class="btn btn-md btn-default btn-block" @click="openModal()">
              Recuperar senha
            </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
         <p>Novas contas: envie um email para sistema@bestuse.com.br</p>
        </div>
      </div>
    </div>

    <div class="row linksPoliticas   fixed-bottom border-top ">
      <div class="mt-2 mb-2 col">
        <div class="row">
          <a class="col-md-4" target="_blank" href="https://bestuse.com.br/politicaPrivacidade.php" title="Clique para acessar">
            Política de privacidade
          </a>
          <a class="col-md-4" target="_blank" href="https://bestuse.com.br/politicaReembolso.php" title="Clique para acessar">
            Política de reembolso
          </a>
          <a class="col-md-4" target="_blank" href="https://bestuse.com.br/termos.php" title="Clique para acessar">
            Termos de serviço
          </a>
          <div class="col-12 text-center">
            <small>© 2019 - BestUse - CNPJ: 11.195.812/0001-56 - Todos os direitos reservados</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode';
import Form from './recuperaSenhaForm';

export default {
  name: 'login',
  props: ['login', 'password'],
  data() {
    return {
      form: {
        login: '',
        password: '',
      },
    };
  },

  beforeCreate() {
    if (this.$store.getters.isLogged) {
      this.$router.push('/');
    }
  },
  mounted() {
    if (this.login) this.form.login = this.login;
    if (this.password) this.form.password = this.password;
  },

  methods: {
    logar() {
      if(this.form.login && this.form.password) {

        this.showError = false;
        this.$http.post('/loginbycc', this.form).then(async (response) => {
          if (response.success) {
            this.successMessage = 'Login efetuado...'
            this.showSuccess = true;

            //setar saldo
            let decoded = jwt_decode(response.token);
            let cc = await this.$http.get(`/v1/recargas/getSaldo/${decoded._id}`);
            this.$store.commit('setSaldo', cc.saldo ? cc.saldo : 0 );

            this.$store.commit('user_login',response);
            this.$router.push({ name: 'EnvioAvulso' });

          } else {
            this.errorMessage = response.message;
            this.showError = true;
          }
        });
      } else {
        this.errorMessage = 'Insira o login e senha';
        this.showError = true;
      }
    },
    openModal() {
      this.$modal.show(
        Form,
        {},
        {
          adaptive: true,
          height:'auto',
          scrollable: true
        },
        {
          closed: () => {
          }
        }
      )
    },
  }
};
</script>


<style >
  .linksPoliticas a{
    font-size: 12px;
    color: #fff !important;
    background-color: #20242e;
  }

  .btn-default {
    color: #fff;
  }

  .btn-default:hover {
    color: #d90f30;
  }
  .btn-info {
    background-color: #d90f30;
  }
  .btn-info:hover {
    background-color: #000;
  }

  #app {
    margin-top: -10px;
  }

</style>
